var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-not"},[_c('div',{staticClass:"text"},[_vm._v("ไม่มีการให้สิทธิ์การเข้าถึง (Not SessionToken)")])])}]

export { render, staticRenderFns }